module.exports = __webpack_public_path__ + "static/media/comment.ef3314f9.svg";